import { useState } from "react";

export default function CopyLinkButton({ vehicleId }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const url = `${window.location.origin}/vehicules/${vehicleId}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button onClick={handleCopy} className="btn btn-outline-secondary btn-sm">
      <i className="bi bi-clipboard me-1"></i>
      {copied ? "Lien copié !" : "Copier lien"}
    </button>
  );
}
